import React, { useEffect, useState } from "react";
import {
  View,
  StyleSheet,
  Text,
  TouchableOpacity,
  Image,
  ScrollView,
  Share as Sharer,
  Linking,
  LayoutAnimation,
  Dimensions,
  StatusBar,
  Alert,
} from "react-native";
import { useHeaderHeight } from "@react-navigation/stack";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Calendar } from "react-native-calendars";
// import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";

import AppText from "../components/AppText";
import CommonFooter from "../components/CommonFooter";
import Screen from "../components/Screen";
import colors from "../config/colors";
import ActivityIndicator from "../components/ActivityIndicator";
import useApi from "../hooks/useApi";
import questions from "../api/questions";
import storage from "../auth/storage";
import { convertDate } from "../util/convertDate";
import { StdAlert } from "../components/CustomAlert";
import MaterialCommunityIcons from "react-native-vector-icons/dist/MaterialCommunityIcons";
import iconFont from "react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf";
import settings from "../config/settings";
const iconFontStyles = `@font-face {
  src: url(${iconFont});
  font-family: MaterialCommunityIcons;
}`;
// Create stylesheet
const style = document.createElement("style");
style.type = "text/css";
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

// Inject stylesheet
document.head.appendChild(style);

function FinalScreen({ navigation, route }) {
  const insets = useSafeAreaInsets();
  const headerHeight = useHeaderHeight();
  const [recordId, setRecordId] = useState(false);
  const submissionApi = useApi(questions.submission);
  const singleSubmissionApi = useApi(questions.getSubmission);
  const slotsApi = useApi(questions.getSlots);
  const insertAppointmentApi = useApi(questions.insertAppointment);
  const [finalData, setFinalData] = useState(
    route.params.lastTwo
      ? JSON.parse(route.params.item.submission_summary)
      : route.params.data
  );
  const [appointmentId, setAppointmentId] = useState();
  const [authToken, setToken] = useState("");
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [payment, setPayment] = useState();
  const [terms, setTerms] = useState(false);
  const [slots, setSlots] = useState();
  const [recommendPaid, setRecommendPaid] = useState(false);
  const [appointmentPaid, setAppointmentPaid] = useState(false);
  const [appointmentExist, setAppointmentExist] = useState();
  const [submissionError, setSubmissionError] = useState();
  // console.log(finalData, 'si');
  const finalPoints =
    parseInt(finalData?.totalPoints || 10) >= 100
      ? 100
      : finalData?.totalPoints;
  const timeForCall = finalPoints < 70 ? "15" : "30";
  const callPayString =
    "Book a " +
    timeForCall +
    " minutes video consultation with our Expert and know the next possible process.";

  const link =
    "\n\nPlay Store: http://play.google.com/store/apps/details?id=bluecard.eu\n\nApp Store: https://itunes.apple.com/us/app/jeewan-drug-store/id1543147867?ls=1&mt=8\n\n";

  const messageToShare =
    "My Blue Card Visa Score is " +
    finalPoints +
    ". Whats yours? You can check your Blue Card Visa Score for FREE! " +
    link +
    "Quickest way on the internet to verify your Score. Check your Blue Card Visa SCORE now.";

  const [paymentType, setPaymentType] = useState("");

  const [showCalender, setShowCalender] = useState(false);
  const [currentDate, setCurrentDate] = useState();

  useEffect(() => {
    async function getDetails() {
      const token = await storage.getToken();
      setToken(token);
      const getName = await storage.getName();
      const getLocation = await storage.getLocation();
      // console.log(getName, getLocation, "jfskl");
      setName(getName);
      setLocation(getLocation);
    }
    async function submitResult() {
      const token = await storage.getToken();
      setToken(token);
      // console.log(finalData, "fsk");
      const result = await submissionApi.request(finalData, token);
      const response = result.data.response;
      console.log(result.data, "jieu");
      if (response.status === "available") {
        // setRecordId(response.record_id);
        // if (response.submission_payment_status === 'Paid') {
        //   setRecommendPaid(true);
        // }
        // if (response.submission_appointment_id) {
        //   setAppointmentPaid(true);
        //   if (response.submission_appointment_id.appointment_slot) {
        //     setAppointmentExist(
        //       response.submission_appointment_id.appointment_slot,
        //     );
        //   }
        // }
        existingRecord(response);
      } else {
        if (response.status === "failure") {
          setSubmissionError(response.message);
          return StdAlert("", response.message);
          // return Alert.alert("", response.message);
        } else {
          console.log("kls", result.data, response.record_id);
          setRecordId(response.record_id);
        }
      }
    }
    async function lastReports() {
      const token = await storage.getToken();
      setToken(token);
      if (route.params.lastTwo) {
        console.log(route.params.item, "fksm");
        setFinalData(JSON.parse(route.params.item.submission_summary));
        existingRecord(route.params.item);
      } else if (route.params.payment_redirect) {
        const result = await singleSubmissionApi.request(
          route.params.submission_id_redirect,
          token
        );
        setFinalData(JSON.parse(result.data.submission_summary));
        existingRecord(result.data);
        if (window.history.pushState) {
          var newurl =
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname +
            "";
          window.history.pushState({ path: newurl }, "", newurl);
        }
        route.params.payment_redirect = null;
      } else {
        submitResult();
      }
    }
    // if (Platform.OS === 'android') {
    //   UIManager.setLayoutAnimationEnabledExperimental &&
    //     UIManager.setLayoutAnimationEnabledExperimental(true);
    // }
    getDetails();
    lastReports();
    return () => {
      console.log("This will be logged on unmount");
    };
  }, []);

  const existingRecord = (response) => {
    // if (response.status === 'available') {
    setRecordId(response.record_id);
    if (response.submission_payment_status === "Paid") {
      setRecommendPaid(true);
    }
    if (response.submission_appointment_id) {
      setAppointmentId(response.submission_appointment_id.record_id);
      setRecommendPaid(true);
      setAppointmentPaid(true);
      if (response.submission_appointment_id.appointment_slot) {
        setCurrentDate(response.submission_appointment_id.appointment_date);
        setAppointmentExist(
          response.submission_appointment_id.appointment_slot
        );
      }
    }
    // }
  };

  const privacyAction = () => {
    const url = "https://bluecardvisa.com/privacy-policy";
    openLink(url);
  };

  const termsAction = () => {
    const url = "https://bluecardvisa.com/terms-of-use";
    openLink(url);
  };

  const websiteAction = () => {
    const url = "https://bluecardvisa.com/";
    openLink(url);
  };

  const openLink = (url) => {
    Linking.canOpenURL(url).then((supported) => {
      if (supported) {
        Linking.openURL(url);
      } else {
        console.log("Don't know how to open URI: " + url);
      }
    });
  };

  const changeDate = () => {
    setSlots(null);
    setShowCalender(true);
  };

  const insertAppointment = async (slot) => {
    // console.log(paymentType, 'fs');
    const result = await insertAppointmentApi.request(
      slot.slot_time,
      recordId,
      currentDate,
      authToken
    );
    console.log(result.data, " iojn");
    if (result.data.response.status === "success") {
      setPayment(null);
      setSlots(null);
      setAppointmentPaid(true);
      setAppointmentExist(slot.slot_time + " " + slot.slot_description);
    }
  };

  const onDetailedReport = async () => {
    if (submissionError) return StdAlert("", submissionError);
    if (recommendPaid) {
      navigation.navigate("Recommendations", finalData);
    } else {
      LayoutAnimation.easeInEaseOut();
      setPayment(payment ? null : "detail");
    }
  };

  const onBookAppointment = () => {
    if (submissionError) return StdAlert("", submissionError);
    if (!appointmentPaid) {
      LayoutAnimation.easeInEaseOut();
      setPayment(payment ? null : "booking");
    } else {
      if (appointmentPaid && !appointmentExist) {
        setShowCalender(true);
      }
    }
  };

  // console.log(StatusBar.currentHeight, headerHeight, 'OPO');

  const onPaypalClick = async () => {
    setPaymentType("Paypal");
    goToPayment("paypal");
    // setShowCalender(true);
    // if (payment === "detail") {
    //   navigation.navigate("Recommendations", finalData);
    // } else {
    //   setShowCalender(true);
    // }
  };

  const goToPayment = async (type) => {
    if (!terms) return StdAlert("", "Please, agree to the Terms");
    const token = await storage.getToken();
    const recordUser = {};
    recordUser.token = token;
    recordUser.record_id = recordId;
    recordUser.type = type;
    recordUser.package = payment === "detail" ? 1 : 2;
    // navigation.navigate("Payment", {
    //   user: recordUser,
    //   // returnData: onPaymentFinished,
    // });
    const finalUrl =
      settings.apiUrl +
      recordUser.type +
      "_web.php?submission_id=" +
      recordUser.record_id +
      "&access_token=" +
      recordUser.token +
      "&payment_package=" +
      recordUser.package;
    window.open(finalUrl, "_self");
  };

  // const onPaymentFinished = (url) => {
  //   // console.log('called, hey', url);
  //   if (payment === 'detail') {
  //     navigation.navigate('Recommendations', finalData);
  //   } else {
  //     setShowCalender(true);
  //   }
  // };

  if (route.params.paySuccess) {
    if (payment === "detail") {
      // navigation.navigate('Recommendations', finalData);
      setPayment(null);
      setRecommendPaid(true);
    } else if (payment === "booking") {
      setPayment(null);
      setRecommendPaid(true);
      setAppointmentPaid(true);
      setShowCalender(true);
    }
    route.params.paySuccess = null;
  }

  const onStripeClick = () => {
    setPaymentType("Stripe");
    goToPayment("stripe");
    // if (!terms) return alert("Please, agree to the Terms");
    // if (payment === "detail") {
    //   navigation.navigate("Recommendations", finalData);
    // } else {
    //   setShowCalender(true);
    // }
  };

  const onShare = async () => {
    try {
      const result = await Sharer.share({
        title: "Take a look at this",
        message: messageToShare,
        quote: messageToShare,
      });
      if (result.action === Sharer.sharedAction) {
        if (result.activityType) {
          // shared with activity type of result.activityType
        } else {
          // shared
        }
      } else if (result.action === Sharer.dismissedAction) {
        // dismissed
      }
    } catch (error) {
      StdAlert("", error.message);
      // Alert.alert("", error.message);
    }
  };

  const onWhatsAppShare = () => {
    const url = "whatsapp://send?text=" + encodeURIComponent(messageToShare);
    openUrl(url);
  };

  const onTwitterShare = () => {
    const url = "twitter://post?message=" + encodeURIComponent(messageToShare);
    openUrl(url);
  };

  const onFbShare = () => {
    // shareOnFacebook(
    //   {
    //     text: messageToShare,
    //     link: messageToShare,
    //     // imagelink: 'https://artboost.com/apple-touch-icon-144x144.png',
    //     //or use image
    //   },
    //   (results) => {
    //     console.log(results);
    //   },
    // );
    const facebookParameters = [];
    facebookParameters.push("quote=" + encodeURI(messageToShare));
    const url =
      "https://www.facebook.com/dialog/feed?" + facebookParameters.join("&");
    openUrl(url);
    // const shareOptions = {
    //   title: 'Share via',
    //   message: messageToShare,
    //   social: Share.Social.FACEBOOK,
    // };

    // Share.shareSingle(shareOptions)
    //   .then((res) => {
    //     console.log(res);
    //   })
    //   .catch((err) => {
    //     err && console.log(err);
    //   });
  };

  const onLinkedInShare = () => {
    const url =
      "http://www.linkedin.com/shareArticle?mini=true&title=" +
      encodeURI(messageToShare);
    openUrl(url);
  };

  const openUrl = (url) => {
    Linking.openURL(url)
      .then((data) => {
        console.log("opened", data);
      })
      .catch(() => {
        console.log("App not installed");
      });
  };

  return (
    <Screen
      style={{
        backgroundColor: colors.light,
        // flex: 1,
        // justifyContent: "space-between",
      }}
    >
      <View style={styles.nameView}>
        <AppText
          color="transparent"
          textColor="white"
          style={{ fontSize: 22, fontWeight: "bold" }}
        >
          {name || ""}
        </AppText>
        <AppText color="transparent" textColor="white">
          {location || ""}
        </AppText>
      </View>
      <ScrollView
        style={{ flexGrow: 1 }}
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: "center",
          // margin: 10,
          paddingBottom: 60,
          minHeight:
            Dimensions.get("window").height -
            140 -
            insets.bottom -
            headerHeight -
            (StatusBar.currentHeight || 0),
        }}
      >
        <View
          style={{
            // flexGrow: 1,
            minHeight:
              Dimensions.get("window").height -
              140 -
              insets.bottom -
              headerHeight -
              (StatusBar.currentHeight || 0),
          }}
        >
          <ActivityIndicator
            visible={
              submissionApi.loading ||
              slotsApi.loading ||
              insertAppointmentApi.loading ||
              singleSubmissionApi.loading
            }
          />

          {!showCalender && (
            <View
              style={[
                styles.middleView,
                {
                  minHeight:
                    Dimensions.get("window").height -
                    140 -
                    insets.bottom -
                    headerHeight -
                    (StatusBar.currentHeight || 0),
                },
              ]}
            >
              {!payment && !slots && (
                <>
                  <AppText
                    textColor="green"
                    style={{ fontSize: 74, fontWeight: "bold" }}
                  >
                    {recommendPaid || appointmentPaid
                      ? "Thanks"
                      : finalPoints >= 100
                      ? 100
                      : finalPoints}
                  </AppText>
                  <AppText
                    style={{
                      fontSize: 20,
                      fontWeight: "600",
                      marginTop: 20,
                      // marginBottom: 20,
                    }}
                  >
                    {recommendPaid || appointmentPaid
                      ? "Your payment was successful"
                      : "What next"}
                  </AppText>
                </>
              )}
              {/* {!payment && ( */}
              <>
                {(!payment || payment === "detail") && !slots && (
                  <TouchableOpacity
                    style={[
                      styles.button,
                      { backgroundColor: colors.yellow, marginTop: 10 },
                    ]}
                    onPress={onDetailedReport}
                  >
                    {/* <Text style={[styles.infoText, {marginRight: 40}]}>
                      {recommendPaid
                        ? 'Payment Done. Check detailed report and recommendations.'
                        : Object.keys(finalData.submission_recommendation)
                            .length +
                          ' Recommendation(s). Access detailed Score Report.'}
                    </Text> */}
                    <Text style={{ maxWidth: "80%" }}>
                      <Text
                        style={[
                          // styles.infoText,
                          { fontWeight: "bold" },
                        ]}
                      >
                        {finalData
                          ? Object.keys(finalData?.submission_recommendation)
                              .length + " Recommendation(s)!"
                          : "0"}
                      </Text>
                      <Text style={styles.infoText}>
                        {"\nAccess detailed Score Report."}
                      </Text>
                    </Text>
                    {!recommendPaid && <Text style={styles.price}>2.9€</Text>}
                    {recommendPaid && (
                      <MaterialCommunityIcons
                        style={[styles.price, { fontSize: 40 }]}
                        name="chevron-right"
                        size={30}
                        color={colors.white}
                      />
                    )}
                  </TouchableOpacity>
                )}
                {(!payment || payment === "booking") && !slots && (
                  <TouchableOpacity
                    style={[
                      styles.button,
                      {
                        backgroundColor: colors.skyblue,
                        marginTop: 10,
                        marginBottom: 60,
                      },
                    ]}
                    onPress={onBookAppointment}
                  >
                    <Text
                      style={[
                        styles.infoText,
                        { color: "white", maxWidth: "80%" },
                      ]}
                    >
                      {!appointmentPaid && (
                        <Text>
                          Make it easy with our Immigration Experts.
                          <Text
                            style={[styles.infoText, { fontWeight: "bold" }]}
                          >
                            {" "}
                            Book a Video Call now.
                          </Text>
                        </Text>
                      )}
                      {!appointmentPaid
                        ? " Score Report included."
                        : appointmentExist
                        ? "Your appointment is on " +
                          convertDate(currentDate) +
                          " at " +
                          appointmentExist
                        : "Take your appointment."}
                    </Text>
                    {!appointmentPaid && (
                      <Text style={[styles.price, { color: "white" }]}>
                        {"76€"}
                      </Text>
                    )}
                    {appointmentPaid && (
                      <MaterialCommunityIcons
                        style={[styles.price, { fontSize: 40 }]}
                        name="chevron-right"
                        size={30}
                        color={colors.white}
                      />
                    )}
                  </TouchableOpacity>
                )}
              </>
              {/* )} */}
              {payment && !slots && (
                <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    // alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <TouchableOpacity
                    style={{
                      // flex: 1,
                      flexDirection: "row",
                      // marginTop: 20,
                      alignItems: "center",
                    }}
                    onPress={() => setTerms(!terms)}
                  >
                    <View
                      style={{
                        borderRadius: 2,
                        borderWidth: 1,
                        borderColor: colors.gray,
                        marginHorizontal: 20,
                        flex: 0.1,
                        height: 30,
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          height: "100%",
                          width: "100%",
                          textAlign: "center",
                          color: colors.gray,
                          fontSize: 20,
                        }}
                      >
                        {terms ? "✓" : " "}
                      </Text>
                    </View>
                    <AppText
                      style={{ marginTop: 20, textAlign: "left", flex: 0.9 }}
                      color="transparent"
                    >
                      I have read the{" "}
                      <Text onPress={privacyAction} style={styles.boldText}>
                        Privacy Policy
                      </Text>{" "}
                      and{" "}
                      <Text onPress={termsAction} style={styles.boldText}>
                        Terms of Use.
                      </Text>{" "}
                      By submitting the payment information I agree that to the
                      terms of use of{" "}
                      <Text onPress={websiteAction} style={styles.boldText}>
                        BlueCardVisa.com
                      </Text>
                    </AppText>
                  </TouchableOpacity>
                  <AppText style={{ marginTop: 20 }}>Pay Via</AppText>
                  <View style={{ flexDirection: "row", width: "100%" }}>
                    <TouchableOpacity
                      style={[
                        styles.paymentButton,
                        { backgroundColor: colors.skyblue },
                      ]}
                      onPress={onPaypalClick}
                    >
                      {/* <Text style={[styles.infoText, { color: "white" }]}>
                        PayPal
                      </Text> */}
                      <Image
                        source={require("../assets/paypal_SVG.png")}
                        style={styles.icon}
                      />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[
                        styles.paymentButton,
                        { backgroundColor: colors.primary, marginTop: 10 },
                      ]}
                      onPress={onStripeClick}
                    >
                      {/* <Text style={[styles.infoText, { color: "white" }]}>
                        stripe
                      </Text> */}
                      <Image
                        source={require("../assets/stripe_SVG.png")}
                        style={styles.icon}
                      />
                    </TouchableOpacity>
                  </View>
                  <View style={{ margin: 10 }}>
                    <Image
                      source={require("../assets/pay_icons.png")}
                      style={{ height: 40, width: 300 }}
                    />
                  </View>
                </View>
              )}

              {!payment && (
                <View style={styles.shareView}>
                  <Text
                    style={[
                      styles.shareIcons,
                      {
                        color: colors.medium,
                        fontSize: 20,
                        width: 60,
                      },
                    ]}
                  >
                    Share
                  </Text>
                  <TouchableOpacity onPress={onShare}>
                    <MaterialCommunityIcons
                      style={styles.shareIcons}
                      name="share-variant"
                      size={30}
                      color={colors.medium}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity onPress={onWhatsAppShare}>
                    <MaterialCommunityIcons
                      style={styles.shareIcons}
                      name="whatsapp"
                      size={30}
                      color={colors.medium}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity onPress={onTwitterShare}>
                    <MaterialCommunityIcons
                      style={styles.shareIcons}
                      name="twitter"
                      size={30}
                      color={colors.medium}
                    />
                  </TouchableOpacity>
                  {/* <TouchableOpacity onPress={onFbShare}>
                    <MaterialCommunityIcons
                      style={styles.shareIcons}
                      name="facebook"
                      size={30}
                      color={colors.medium}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity onPress={onLinkedInShare}>
                    <MaterialCommunityIcons
                      style={styles.shareIcons}
                      name="linkedin"
                      size={30}
                      color={colors.medium}
                    />
                  </TouchableOpacity> */}
                </View>
              )}
              {appointmentPaid && slots && (
                <>
                  {slots.length > 0 && (
                    <AppText style={{ marginTop: 10 }}>
                      Select a Time Slot
                    </AppText>
                  )}
                  {slots.length === 0 && (
                    <AppText
                      color="danger"
                      textColor="white"
                      style={{
                        marginTop: 10,
                        paddingHorizontal: 10,
                        textAlign: "center",
                      }}
                    >
                      Sorry, All slots are booked for the selected day.
                    </AppText>
                  )}
                  {slots.map((slot) => (
                    <TouchableOpacity
                      style={[styles.recommendView]}
                      key={slot.slot_time}
                      onPress={() => insertAppointment(slot)}
                    >
                      <View>
                        <AppText
                          color="newGray"
                          textColor="black"
                          style={styles.recommendTitle}
                        >
                          {slot.slot_time}
                        </AppText>
                        <AppText
                          color="newGray"
                          textColor="gray"
                          style={styles.recommendPoints}
                        >
                          {slot.slot_description}
                        </AppText>
                      </View>
                    </TouchableOpacity>
                  ))}
                  <AppText
                    color="recommend"
                    style={{ marginTop: 20, marginBottom: 50, fontSize: 16 }}
                    onPress={changeDate}
                  >
                    {"  Change Date  "}
                  </AppText>
                </>
              )}
            </View>
          )}
          {showCalender && (
            <View
              style={{
                flexGrow: 1,
                backgroundColor: colors.white,
                justifyContent: "center",
                margin: 10,
              }}
            >
              <AppText
                textColor="gray"
                style={{
                  alignSelf: "center",
                  marginBottom: 20,
                  marginTop: 10,
                  fontWeight: "700",
                }}
              >
                Select a Date
              </AppText>
              <Calendar
                current={new Date()}
                minDate={Date.now()}
                maxDate={new Date(Date.now() + 10 * 24 * 60 * 60 * 1000)}
                onDayPress={async (day) => {
                  console.log("selected day", day);
                  setCurrentDate(day.dateString);
                  //{[day.dateString]:{selected: true, selectedColor: '#466A8F'}}
                  const timestamp = day.timestamp; // UNIX timestamp in seconds
                  const days = [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ];
                  const xx = new Date();
                  xx.setTime(timestamp); // javascript timestamps are in milliseconds
                  // console.log(xx.toUTCString());
                  console.log(days[xx.getDay()]);
                  const result = await slotsApi.request(
                    authToken,
                    days[xx.getDay()],
                    day.dateString,
                    days[xx.getDay()]
                  );
                  console.log(result.data, "smk");
                  setSlots(result.data.slot);
                  setShowCalender(false);
                }}
              />
            </View>
          )}
        </View>
      </ScrollView>
      <View style={{ position: "absolute", bottom: 0 }}>
        <CommonFooter navigation={navigation} />
      </View>
    </Screen>
  );
}

const styles = StyleSheet.create({
  nameView: {
    alignItems: "center",
    justifyContent: "center",
    height: 80,
    backgroundColor: colors.lightGreen,
  },
  middleView: {
    // flexGrow: 1,
    backgroundColor: colors.white,
    alignItems: "center",
    justifyContent: "center",
    // margin: 10,
  },
  scrollView: {},
  button: {
    borderRadius: 8,
    padding: 20,
    width: "90%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  boldText: {
    color: "#696969",
    fontWeight: "bold",
    textDecorationLine: "underline",
  },
  paymentButton: {
    borderRadius: 8,
    padding: 10,
    margin: 10,
    width: "45%",
    // height: 80,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  price: {
    fontSize: 22,
    fontWeight: "bold",
    // marginRight: 20,
    // position: 'absolute',
    alignSelf: "center",
  },
  infoText: {
    // fontWeight: '500',
  },
  shareView: {
    flexDirection: "row",
    backgroundColor: colors.white,
    alignItems: "center",
    justifyContent: "center",
    // marginTop: 20,
    bottom: 0,
    position: "absolute",
    opacity: 0,
  },
  shareIcons: {
    height: 30,
    width: 30,
    marginLeft: 10,
    marginBottom: 10,
  },
  icon: {
    width: "50%",
    height: 60,
    alignSelf: "center",
  },
  recommendView: {
    // flex: 1,
    flexDirection: "column",
    borderRadius: 20,
    width: "100%",
    minHeight: 60,
    backgroundColor: colors.newGray,
    marginVertical: 10,
    justifyContent: "center",
    alignItems: "center",
    // justifyContent: "space-between",
  },
  recommendTitle: {
    // left: 10,
    marginTop: 10,
    fontWeight: "700",
    textAlign: "center",
  },
  recommendPoints: {
    // left: 10,
    textAlign: "center",
    marginVertical: 10,
    fontSize: 14,
    // alignSelf: 'flex-end',
  },
});

export default FinalScreen;
